import Immutable from 'immutable'

const initialErrors = null

const actionHandlers = {
    RESET_SEARCH_RESULTS: () => initialErrors,
    UPDATE_FILTERS: () => initialErrors,
    RESET_FILTERS: () => initialErrors,
    REQUEST_VIEW_SEARCH: () => initialErrors,
    REQUEST_BANKRUPTCY_SEARCH: () => initialErrors,
    REQUEST_BANKRUPTCY_LOCAL_SEARCH: () => initialErrors,
    REQUEST_APPELLATE_SEARCH: () => initialErrors,
    REQUEST_CIVIL_SEARCH: () => initialErrors,
    REQUEST_CRIMINAL_SEARCH: () => initialErrors,

    REQUEST_CASE_DATA_OF_CASE_LOOKUP: () => initialErrors,

    RESET_VALIDATION_ERROR: () => initialErrors,
    VALIDATION_ERROR: (state, action) => Immutable.fromJS(action.errors),
}

export default (validationErrors = initialErrors, action) => {
    const actionHandler = actionHandlers[action.type]

    return (actionHandler)
        ? actionHandler(validationErrors, action)
        : validationErrors
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/validationErrors.js
 **/